import {z} from "zod/v4-mini"
import {materialUiSchema} from "#material/nodes/base/material/validation/ui"
import type {MaterialNodeSockets} from "#material/types/material-node-sockets"
import {ExchangeNodeName} from "#material/exchange/node-name"
import type {MaterialNodeDefinition} from "#material/nodes/base/material/types/definition"
import {color} from "@cm/graph-v3"
import {vec3} from "#material/types/vector"

export interface MaterialGroupSockets extends MaterialNodeSockets {
    inputs: {}
    settings: {
        input_1: "vector" // found in inputs: -; found in settings: vector; inferred from data: float3
        input_11: "float" // found in inputs: -; found in settings: float; inferred from data: float
        input_21: "float" // found in inputs: -; found in settings: float; inferred from data: float
        input_23: "float" // found in inputs: -; found in settings: float; inferred from data: float
        input_3: "color" // found in inputs: -; found in settings: color,float; inferred from data: float3,float
        input_5: "color" // found in inputs: -; found in settings: color; inferred from data: float3
        input_7: "color" // found in inputs: -; found in settings: color; inferred from data: float3
        input_9: "float" // found in inputs: -; found in settings: float; inferred from data: float
        output_11: "float" // found in inputs: -; found in settings: float; inferred from data: float
        output_9: "color" // found in inputs: -; found in settings: color; inferred from data: float3
    }
    outputs: {}
}

export const materialGroupDefinition = {
    exchangeFormat: {
        nodeName: ExchangeNodeName.ShaderNodeGroup,
    },
    nodeClass: "MaterialGroup",
    ui: {
        label: "Group",
        color: "#6e5eb2",
        items: [],
        support: {
            cycles: false,
            three: false,
        },
    },
    validation: {
        returns: z.strictObject({}),
        parameters: z.strictObject({
            inputs: z.strictObject({}),
            settings: z.strictObject({
                input_1: z.optional(vec3),
                input_11: z.optional(z.number()),
                input_21: z.optional(z.number()),
                input_23: z.optional(z.number()),
                input_3: z.optional(color),
                input_5: z.optional(color),
                input_7: z.optional(color),
                input_9: z.optional(z.number()),
                output_11: z.optional(z.number()),
                output_9: z.optional(color),
            }),
            ui: materialUiSchema,
        }),
    },
} satisfies MaterialNodeDefinition<MaterialGroupSockets>
